"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PolicyVersionDetails = /** @class */ (function () {
    function PolicyVersionDetails() {
    }
    return PolicyVersionDetails;
}());
exports.default = PolicyVersionDetails;
//# sourceMappingURL=PolicyVersionDetails.js.map